// extracted by mini-css-extract-plugin
export default {"container":"_p-z","heading":"aq-z","text":"bq-z","info":"cq-z","link":"dq-z","fullMaxWidth":"eq-z"};